export default __webpack_public_path__ + "static/media/secure.65edf64f.png";